module.exports = "/ThumbsUpActive@2x-15ab19df698dd58bc3f0d182473e927a.png";